import { Injectable } from '@angular/core';
import { munchkinProvide } from './munchkin/munchkin';

declare let window: any;

@Injectable({ providedIn: 'root' })
export class Munchkin {
  constructor() {}

  munchkinStart() {
    munchkinProvide(window);
  }
}
